module.exports = __webpack_public_path__ + "static/img/h3.81210a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h3.jpg
// module id = bSZb
// module chunks = 0